/*
 *  Server side API
 *
 *  @version 1.0
 *
 **/
module.exports = ( Vue ) => { 

    Vue.prototype.ajax = {

        //Loader
        ldr : $('#ldr'),
        l2  : false,

        //Ajax Sign-out
        signOut() {
            //this.loader('show');

            $.ajax({
                type    : 'POST',
                url     : '/logout',

                //Logout success, reload page
                success() {
                    location.reload();
                },

                //Backend error
                error() {

                }
            });

        },

        isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }

            return true;
        },

        //Ajax Calls
        call( url, data, callback, headers, errorCB ) {

            if( window._lc == 1 && Vue.prototype.auth.user && typeof window._enableSCom_x11 == 'boolean' ) {
                data._uid = Vue.prototype.auth.user.id;
            }
            
            if( typeof data.noLoad == 'undefined' ) {

                this.loader('show');
            
            }
            
            var me = this,
                hdr = {};

            if( typeof headers == 'object' ) {
                hdr = Object.assign({}, headers);
            }

            var params = {
                type : "POST",
                url  : "/system/" + url,
                data : data,
                headers : hdr,

                success : function( response, textStatus, request ){
                    if(typeof callback == 'function'){
                        
                        if( typeof response.data == 'string' ){
                            response.data = JSON.parse( response.data );
                        }

                        let l1 ='teLi';
                        let l2 = 't-Fr';

                        callback( response, request.getResponseHeader('X-Ra' + l1 + 'mi' + l2 + 'om') );
                    }
                },

                error : function(response){
                    // $.notify('An unexpected error has occured, please try again later','warning');
                    
                    var data = { 
                        url     : '/system/' + url, 
                        data    : JSON.stringify(data), 
                        file    : '', 
                        line    : '', 
                        message : '', 
                        status  : response.status
                    };

                    if( typeof response.responseJSON == 'object' ){
                    
                        data.file    = response.responseJSON.file;
                        data.line    = response.responseJSON.line;
                        data.message = response.responseJSON.message;
                    
                    } else {

                        data.message = responseText.substr(0,200);

                    }

                    if( typeof errorCB == 'function' ) {
                        errorCB( response );
                    }

                    //Log error for inspection
                    // $.ajax({ url : '/system/logAjaxError', data : data, type : "POST" });
                }

            };

            if( typeof grecaptcha != 'undefined' ) {

                grecaptcha.ready(function() {
                    grecaptcha.execute( window._rcv3sk, {action: 'submit'}).then(function(token) {
                        
                        data._v3t = token;

                        $.ajax( params ).done(function(){
                            
                            me.loader('hide');
                        });
                 
                    });
                });
                
            } else {

                data._v3t = 'TOKEN';

                $.ajax( params ).done(function(){
                    
                    me.loader('hide');
                });
            }


        },

        //Ajax Calls
        callNew( url, data, callback, callbackErr, headers ) {
            
            if( typeof data.noLoad == 'undefined' ) {
                this.loader('show');
            }
            
            var me = this,
                hdr = {};

            if( typeof headers == 'object' ) {
                hdr = Object.assign({}, headers);
            }

            var params = {
                type : "POST",
                url  : "/system/" + url,
                data : data,
                headers : hdr,

                success : function( response, textStatus, request ){
                    if(typeof callback == 'function'){

                        let data = false;
                        
                        if( typeof response.data == 'string' && me.isJson( response.data ) ){
                            data = JSON.parse( response.data );
                        } else {
                            data = response.data;
                        }

                        if( response.status == 'success' ) {
                            callback( data );
                        } else {

                            if( typeof callbackErr == 'function' ) {
                                callbackErr( response.status, response.message );
                            } else {
                                $.notify( response.message, "warning" );
                            }

                        }
                    }
                },

                error : function(response){
                    
                    if( typeof callbackErr == 'function' ) {
                        callbackErr( response );
                    } else {
                        $.notify("We are sorry, but an unexpected problem has occured.","warning");
                    }
                }

            };

            if( typeof grecaptcha != 'undefined' ) {

                grecaptcha.ready(function() {
                    grecaptcha.execute( window._rcv3sk, {action: 'submit'}).then(function(token) {
                        
                        data._v3t = token;

                        $.ajax( params ).done(function(){
                            
                            me.loader('hide');
                        });
                 
                    });
                });

            } else {

                data._v3t = 'TOKEN';

                $.ajax( params ).done(function(){
                    
                    me.loader('hide');
                });
            }

        },

        loader(command, to) {
            // if(!this.ldr.length){
            //     this.ldr = $("<div id='ldr'><h2>Моля изчакайте...</h2><img src='/images/loader.svg'/></div>");
            //     this.ldr.appendTo($('body')); 
            // }

            switch( command ) {
                // case 'show'     : bus.$emit('loader', true); break;
                // case 'hide'     : bus.$emit('loader', false); break;
                // case 'remove'   : this.ldr.remove(); break;
            }
        },

        resolveError(){
            // var h1  = $("<h3>Възникна неочакван проблем</h3>");
            // var btn = $("<button class='btn btn-primary ' onclick='location.reload()'>Презареди</button>");

            // this.ldr.html('');
            // h1.appendTo(this.ldr);
            // btn.appendTo(this.ldr);

            // this.loader('show');
        }
    }

}